
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/courses/marketing",
      function () {
        return require("private-next-pages/next/courses/marketing.tsx");
      }
    ]);
  